import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

export const useNotificationTypes = (options = {}) =>
  useQuery({
    queryKey: ['NOTIFICATION_TYPES'],
    queryFn: async () => {
      const response = await httpService.get('notification-type/list');
      return response.data.data;
    },
    refetchOnWindowFocus: false,
    ...options,
  });

export const useCreateNotificationType = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options;

  return useMutation({
    mutationKey: ['CREATE_NOTIFICATION_TYPE'],
    mutationFn: async (body) => {
      const response = await httpService.post('notification-type/create', body);
      return response.data.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['NOTIFICATION_TYPES'] });
      if (onSuccess) onSuccess(data, variables, context);
    },
    ...rest,
  });
};

export const useUpdateNotificationType = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options;

  return useMutation({
    mutationKey: ['UPDATE_NOTIFICATION_TYPE'],
    mutationFn: async ({ id, body }) => {
      const response = await httpService.post(`notification-type/update/${id}`, body);
      return response.data.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['NOTIFICATION_TYPES'] });
      if (onSuccess) onSuccess(data, variables, context);
    },
    ...rest,
  });
};

export const useDeleteNotificationType = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options;

  return useMutation({
    mutationKey: ['DELETE_NOTIFICATION_TYPE'],
    mutationFn: async (id) => {
      const response = await httpService.post(`notification-type/delete/${id}`);
      return response.data.data;
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['NOTIFICATION_TYPES'] });
      if (onSuccess) onSuccess(data, variables, context);
    },
    ...rest,
  });
};

export const useAdminNotifications = ({ params, options = {} }) =>
  useQuery({
    queryKey: ['ADMIN_NOTIFICATIONS', params],
    queryFn: async () => {
      const response = await httpService.post('notifications/admin/list', params);
      return response.data.data;
    },
    refetchOnWindowFocus: false,
    ...options,
  });
